export const TOGGLE_MSG = 'Select Dealer';
export const TOGGLE_ERROR_MSG = 'Please select a dealer';

export const COMMUNITY_TITLE = 'Make our community smarter';
export const COMMUNITY_BTN = 'Share with Community';
export const COMMUNITY_MESSAGE =
  'Consider sharing this deal with other car shoppers. It takes seconds and helps others know who is offering the best deals.';

export const SHARE_COMMUNITY_MODE = {
  DISPLAY_OPTION_BEFORE_RATING: 'BEFORE_RATING',
  DISPLAY_OPTION_AFTER_RATING: 'AFTER_RATING',
  DISPLAY_OPTION_CTA_ONLY: 'CTA_ONLY',
};

export const FORM_LABELS = {
  [SHARE_COMMUNITY_MODE.DISPLAY_OPTION_BEFORE_RATING]: {
    title: '',
    text: 'Dealer who offered this deal (optional)',
    textclass: 'size-16 mb-0_5',
  },
  [SHARE_COMMUNITY_MODE.DISPLAY_OPTION_AFTER_RATING]: {
    title: 'Is this an offer from a dealer?',
    text: 'If so, consider sharing it with other car shoppers. It takes seconds and helps others know who is offering the best deals.',
    textclass: 'size-16 mb-1',
  },
};
